import { lazy } from 'react'

// Lazy load main components
const Hmda = lazy(() => import('pages/Loan/HMDA'))
const LoanEstimatePage1 = lazy(() => import('pages/Loan/LoanEstimatePages/LoanEstimatePage1'))
const LoanEstimatePage2 = lazy(() => import('pages/Loan/LoanEstimatePages/LoanEstimatePage2'))
const LoanEstimatePage3 = lazy(() => import('pages/Loan/LoanEstimatePages/LoanEstimatePage3'))
const ClosingDisclosurePage1 = lazy(() => import('pages/Loan/ClosingDisclosurePage/ClosingDisclosurePage1'))
const ClosingDisclosurePage2 = lazy(() => import('pages/Loan/ClosingDisclosurePage/ClosingDisclosurePage2'))
const ClosingDisclosurePage3 = lazy(() => import('pages/Loan/ClosingDisclosurePage/ClosingDisclosurePage3'))
const ClosingDisclosurePage4 = lazy(() => import('pages/Loan/ClosingDisclosurePage/ClosingDisclosurePage4'))
const ClosingDisclosurePage5 = lazy(() => import('pages/Loan/ClosingDisclosurePage/ClosingDisclosurePage5'))
const ClosingDisclosureAddendum = lazy(() => import('pages/Loan/ClosingDisclosurePage/ClosingDisclosureAddendum'))
const TransmittalSummary1008 = lazy(() => import('pages/Loan/TransmittalSummary1008'))
const Reminders = lazy(() => import('pages/Reminders'))
const LoanActions = lazy(() => import('pages/Loan/LoanActions'))
const LoanChangeRequest = lazy(() => import('pages/Loan/LoanChangeRequest'))
const DocumentGenie = lazy(() => import('pages/Loan/DocumentGenie/DocumentGenie'))
const ClosingCalendar = lazy(() => import('pages/Loan/ClosingCalendar'))
const SecondaryMarketingScreen = lazy(() => import('pages/Loan/SecondaryMarketing/SecondaryMarketingScreen'))
const ReviewForm = lazy(() => import('pages/Loan/Underwriting/ReviewForm/ReviewForm'))
const ExpirationDates = lazy(() => import('pages/Loan/Underwriting/ExpirationDates'))
const UnderwritingSummary = lazy(() => import('pages/Loan/Underwriting/UnderwritingSummary'))
const AppraisalInformation = lazy(() => import('pages/Loan/Underwriting/AppraisalInformation'))
const ContractorApplication = lazy(() => import('pages/Loan/ContractorApplications'))
const FeeWorkSheet = lazy(() => import('pages/Loan/FeeWorkSheet'))
const BudgetScopeOfWork = lazy(() => import('pages/Loan/Budget'))
const BorrowingBase = lazy(() => import('pages/Loan/Servicing/BorrowingBase'))
const Mers = lazy(() => import('pages/Loan/MERS'))
const Notes = lazy(() => import('pages/Loan/Servicing/Notes/Notes'))
const AddAppraisalInformationV2 = lazy(() => import('pages/Loan/OrderAppraisals/AddAppraisalInformationV2'))

// Underwriting components
const NYTransactions = lazy(() => import('pages/Loan/Underwriting/NYTransactions'))
const EscrowHoldbackAgreement = lazy(() => import('pages/Loan/Underwriting/EscrowHoldbackAgreement'))
const OrderOuts = lazy(() => import('pages/Loan/Underwriting/OrderOuts'))
const PropertyLogistics = lazy(() => import('pages/Loan/Underwriting/PropertyLogistics'))

// Dataverify components
const SSA = lazy(() => import('pages/Loan/Underwriting/Dataverify/SSA'))
const Tax = lazy(() => import('pages/Loan/Underwriting/Dataverify/Tax'))
const FraudGaurd = lazy(() => import('pages/Loan/Underwriting/Dataverify/FraudGaurd'))
const Lexis = lazy(() => import('pages/Loan/Underwriting/Dataverify/Lexis'))

// PostClosing components
const Allonge = lazy(() => import('pages/Loan/PostClosing/Allonge'))
const Assignment = lazy(() => import('pages/Loan/PostClosing/Assignment'))
const TransferLetter = lazy(() => import('pages/Loan/PostClosing/TransferLetter'))
const ServicingTransfer = lazy(() => import('pages/Loan/PostClosing/ServicingTransfer'))
const PurchaseAdvice = lazy(() => import('pages/Loan/PostClosing/PurchaseAdvice'))
const PurchaseAdviceSeller = lazy(() => import('pages/Loan/PostClosing/PurchaseAdviceSeller'))
const DownloadDocuments = lazy(() => import('pages/Loan/PostClosing/DownloadDocuments'))
const ShippingInformation = lazy(() => import('pages/Loan/PostClosing/ShippingInformation'))
const AmortizationScheduleContent = lazy(() => import('pages/Loan/AmortizationSchedule/AmortizationScheduleContent'))
const LoanTrade = lazy(() => import('pages/Loan/PostClosing/LoanTrade'))
const CollateralReview = lazy(() => import('pages/Loan/PostClosing/CollateralReview'))
const SetPoint = lazy(() => import('pages/Loan/PostClosing/SetPoint/index'))

// Servicing components
const ACH = lazy(() => import('pages/Loan/Servicing/ACH'))
const TrustLedger = lazy(() => import('pages/Loan/Servicing/TrustLedger'))
const ServicingDocument = lazy(() => import('pages/Loan/Servicing/ServicingDocument'))
const LoanExtension = lazy(() => import('pages/Loan/Servicing/LoanExtension/LoanExtension'))
const ServicingParticipation = lazy(() => import('pages/Loan/Servicing/Participation'))
const DefaultTracking = lazy(() => import('pages/Loan/Servicing/DefaultTracking'))
const CreditReporting = lazy(() => import('pages/Loan/Servicing/CreditReporting'))
const CollectionCalls = lazy(() => import('pages/Loan/Servicing/CollectionCalls/CollectionCalls'))
const TextMessages = lazy(() => import('pages/Loan/Servicing/TextMessages'))
const BorrowerPortal = lazy(() => import('pages/Loan/Servicing/BorrowerPortal'))
const PartyPayments = lazy(() => import('pages/Loan/Servicing/PartyPayments'))
const PaymentVouchers = lazy(() => import('pages/Loan/Servicing/PaymentVouchers'))
const Vouchers = lazy(() => import('pages/Loan/Servicing/Vouchers'))
const ServicingBorrowerInformation = lazy(() => import('pages/Loan/Servicing/BorrowerInformation'))
const ServicingPropertyInformation = lazy(() => import('pages/Loan/Servicing/PropertyInformation'))
const LoanAiProject = lazy(() => import('pages/Loan/AiProject'))
const ServicingNote = lazy(() => import('pages/Loan/Servicing/ServicingNotes/ServicingNote'))
const Invoice = lazy(() => import('pages/Loan/Servicing/Invoice/Invoice'))
const StripeInvoices = lazy(() => import('pages/Loan/Invoice/Invoices'))
const Payoff = lazy(() => import('pages/Loan/Servicing/Payoff'))
const Reinstatement = lazy(() => import('pages/Loan/Servicing/Reinstatement'))
const LoanStatements = lazy(() => import('pages/Loan/Servicing/Statements'))
const RateChanges = lazy(() => import('pages/Loan/Servicing/RateChanges'))
const LoanPayments = lazy(() => import('pages/Loan/Servicing/LoanPayments'))
const LoanCharges = lazy(() => import('pages/Loan/Servicing/LoanCharges/LoanCharges'))
const Penalties = lazy(() => import('pages/Loan/Servicing/Penalties'))
const Contacts = lazy(() => import('pages/Loan/Servicing/Contacts/Contacts'))
const FciDetail = lazy(() => import('pages/Loan/Fci/index'))

// ClosingScreen components
const DocumentGenerate = lazy(() => import('pages/Loan/ClosingScreen/GenerateDocuments'))
const LightningDocs = lazy(() => import('pages/Loan/ClosingScreen/LightningDocs'))
const AutomateLoanDocs = lazy(() => import('pages/Loan/ClosingScreen/AutomateLoanDocs'))
const GoDocs = lazy(() => import('pages/Loan/ClosingScreen/GoDocs'))
const DocMagic = lazy(() => import('pages/Loan/ClosingScreen/DocMagic'))
const AggregateEscrow = lazy(() => import('pages/Loan/ClosingScreen/AggregateEscrow'))
const HUD1Page1 = lazy(() => import('pages/Loan/ClosingScreen/HUD1Page1'))
const HUD1Page2 = lazy(() => import('pages/Loan/ClosingScreen/HUD1Page2'))
const HUD1Page3 = lazy(() => import('pages/Loan/ClosingScreen/HUD1Page3'))
const Funding = lazy(() => import('pages/Loan/ClosingScreen/Funding'))

// LoanIntake components
const LoanIntakeDocument = lazy(() => import('pages/Loan/LoanInTake/LoanIntakeDocument'))
const LoanDetailValidation = lazy(() => import('pages/Loan/LoanInTake/LoanDetailValidation'))
const TridImportantDates = lazy(() => import('pages/Loan/LoanInTake/TridImportantDates'))
const RicherValues = lazy(() => import('pages/Loan/LoanInTake/RicherValues'))
const NationalFlood = lazy(() => import('pages/Admin/Vendors/NationalFlood/NationalFlood'))

// Funding components
const Disbursement = lazy(() => import('pages/Loan/Funding/Disbursement'))

// Credit Denial
const CreditDenial = lazy(() => import('pages/Loan/CreditDenial'))

// Rental Ledger
const RentalLedger = lazy(() => import('pages/Loan/Reo/RentalLedger/RentalLedger'))

// Property Profile
const PropertyProfile = lazy(() => import('pages/Loan/Reo/PropertyProfile/PropertyProfile'))

// Financial Tracking
const FinancialTracking = lazy(() => import('pages/Loan/Reo/FinancialTracking/FinancialTracking'))

// Disposition Strategy
const DispositionStrategy = lazy(() => import('pages/Loan/Reo/DispositionStrategy/DispositionStrategy'))

// REO Contacts
const ReoContacts = lazy(() => import('pages/Loan/Reo/ReoContacts/ReoContacts'))

// Property Expense
const PropertyExpense = lazy(() => import('pages/Loan/Reo/PropertyExpense/PropertyExpense'))

// Improvement Ledger
const ImprovementLedger = lazy(() => import('pages/Loan/Reo/ImprovementLedger/ImprovementLedger'))

// REO Documents
const ReoDocument = lazy(() => import('pages/Loan/Reo/ReoDocument'))

const DrawRequest = lazy(() => import('pages/Borrower/DrawRequest/BorrowerDrawRequest'))

const ServicingReport = lazy(() => import('pages/Loan/Servicing/ServicingReport/ServicingReport'))

const TaxForms = lazy(() => import('pages/Loan/Servicing/TaxForms/TaxForms'))

const Compliance = lazy(() => import('pages/Loan/Compliance/Compliance'))

const Parties = lazy(() => import('pages/Loan/Parties'))
const EmailRestrictions = lazy(() => import('pages/Loan/EmailRestrictions'))

// Placeholder component for features not yet integrated
const ComingSoon = () => <div>Coming Soon...</div>

/**
 * Component map that maps submenu keys to their corresponding React components
 * These keys should match the keys from the constant.ts subMenus object
 */
export const ComponentMap: Record<string, React.ComponentType<any>> = {
  // Loan features
  loanChangeRequest: LoanChangeRequest,
  orderValuation: AddAppraisalInformationV2,
  documentGenie: DocumentGenie,
  globalNotes: Notes,
  loanActions: LoanActions,
  servicingNotes: Notes,
  closingCalendar: ClosingCalendar,
  nationFlood: NationalFlood,
  dataVerifySSA: SSA,
  dataVerify4506: Tax,
  dataVerifyDrive: FraudGaurd,
  lexis: Lexis,
  servicingInformation: ServicingNote,
  orderOuts: OrderOuts,
  propertyLogistics: PropertyLogistics,
  loanIntakeDocuments: LoanIntakeDocument,
  loanDetailValidation: LoanDetailValidation,
  tridImportantDates: TridImportantDates,
  richerValues: RicherValues,
  secondaryMarketing: SecondaryMarketingScreen,
  appraisalReview: ReviewForm,
  expirationDates: ExpirationDates,
  underwritingSummary: UnderwritingSummary,
  appraisalInformation: AppraisalInformation,
  nyTransactions: NYTransactions,
  escrowHoldbackAgreement: EscrowHoldbackAgreement,
  documentGenerate: DocumentGenerate,
  lightningDocs: LightningDocs,
  automateLoanDocs: AutomateLoanDocs,
  goDocs: GoDocs,
  docMagic: DocMagic,
  aggregateEscrow: AggregateEscrow,
  hud1Page1: HUD1Page1,
  hud1Page2: HUD1Page2,
  hud1Page3: HUD1Page3,
  hud1A: HUD1Page2, // HUD1A uses HUD1Page2 with different props
  funding: Funding,
  general: ComingSoon,

  // Post Closing
  allonge: Allonge,
  assignment: Assignment,
  transferLetter: TransferLetter,
  servicingTransfer: ServicingTransfer,
  purchaseAdviceBuyer: PurchaseAdvice,
  purchaseAdviceSeller: PurchaseAdviceSeller,
  crossRiverAssignmentDocs: DownloadDocuments,
  shippingInformation: ShippingInformation,
  amortizationSchedule: AmortizationScheduleContent,
  postClosingLoanTrade: LoanTrade,
  collateralReview: CollateralReview,
  setPoint: SetPoint,

  // Servicing
  ach: ACH,
  trustLedger: TrustLedger,
  servicingDocument: ServicingDocument,
  loanExtensions: LoanExtension,
  participation: ServicingParticipation,
  defaultTracking: DefaultTracking,
  creditReporting: CreditReporting,
  collectionCalls: CollectionCalls,
  textMessages: TextMessages,
  tasks: () => null, // Link to external route
  invoice: Invoice,
  stripeInvoices: StripeInvoices,
  payoff: Payoff,
  reinstatement: Reinstatement,
  statements: LoanStatements,
  rateChanges: RateChanges,
  budget: BudgetScopeOfWork,
  loanPayments: LoanPayments,
  loanCharges: LoanCharges,
  penalties: Penalties,
  contacts: Contacts,
  // Servicing shows the same full FCI screen as origination.
  fci: FciDetail,
  fciDetail: FciDetail,
  mers: Mers,
  borrowerPortal: BorrowerPortal,
  partyPayments: PartyPayments,
  paymentVouchers: PaymentVouchers,
  vouchers: Vouchers,
  borrowerInformation: ServicingBorrowerInformation,
  propertyInformation: ServicingPropertyInformation,
  aiProject: LoanAiProject,

  // Funding
  disbursementInformation: Disbursement,

  // Other
  contractorApplication: ContractorApplication,
  reminders: Reminders,
  feeWorksheet: FeeWorkSheet,
  hmda: Hmda,
  loanEstimatePage1: LoanEstimatePage1,
  loanEstimatePage2: LoanEstimatePage2,
  loanEstimatePage3: LoanEstimatePage3,
  closingDisclosurePage1: ClosingDisclosurePage1,
  closingDisclosurePage2: ClosingDisclosurePage2,
  closingDisclosurePage3: ClosingDisclosurePage3,
  closingDisclosurePage4: ClosingDisclosurePage4,
  closingDisclosurePage5: ClosingDisclosurePage5,
  closingDisclosureAddendum: ClosingDisclosureAddendum,
  transmittalSummary1008: TransmittalSummary1008,
  rentalLedger: RentalLedger,
  reoNotes: Notes,
  propertyProfile: PropertyProfile,
  financialTracking: FinancialTracking,
  dispositionStrategy: DispositionStrategy,
  reoContacts: ReoContacts,
  propertyExpense: PropertyExpense,
  improvementLedger: ImprovementLedger,
  reoDocument: ReoDocument,
  drawRequest: DrawRequest,
  borrowingBase: BorrowingBase,
  creditDenial: CreditDenial,
  servicingReport: ServicingReport,
  taxForms: TaxForms,

  compliance: Compliance,
  parties: Parties,
  emailRestrictions: EmailRestrictions,
}

/**
 * Get component by key, returns a default "Coming Soon" component if not found
 */
export const getComponent = (key: string): React.ComponentType<any> => {
  return ComponentMap[key] || ComingSoon
}
